"use client";
import { jsx } from "react/jsx-runtime";
import { Button } from "@nxt-costco-com/forge-components";
import { buttonStyles } from "./styles.js";
const COMPONENT_NAME = "ProductActions";
const ProductDetailsButton = ({
  type,
  productActionsVariant,
  seedetailsbuttonlabel,
  selectoptionsbuttonlabel,
  pdpNavigationUrl,
  productInfoData,
  productTitleId
}) => {
  const buttonLabel = type === productActionsVariant.SeeDetails ? seedetailsbuttonlabel : selectoptionsbuttonlabel;
  return /* @__PURE__ */ jsx(
    Button,
    {
      "aria-describedby": productTitleId,
      href: pdpNavigationUrl,
      sx: buttonStyles,
      uniqueId: `${COMPONENT_NAME}_${productInfoData.partNumber}`,
      variant: "primary",
      children: buttonLabel
    }
  );
};
export {
  ProductDetailsButton
};
